module.exports = __webpack_public_path__ + "img/glasses.7750704e.svg";